import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules';
import store from '@/app/store';

@Module
class AppDrawerModule extends VuexModule {
    private state = {
        open: false,
    };

    get isOpen() {
        return this.state.open;
    }

    @Action
    public toggleDrawer(): void {
        this.setDrawer(!this.state.open);
    }
    @Action
    public updateDrawer(value: boolean): void {
        this.setDrawer(value);
    }

    @Mutation
    private setDrawer(value: boolean): void {
        this.state.open = value;
    }
}

export const appDrawerModule = new AppDrawerModule({
    store,
    name: 'appDrawerModule',
});
